export default "__VITE_ASSET__hfsnJ5M0__"